import '../Assets/Styles/general.css';
import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate,useLocation,Route,Routes,Navigate} from 'react-router-dom';
import io from 'socket.io-client';
import { serverLogout, setOnRefreshed, refreshAccessToken, startProactiveRefresh, stopProactiveRefresh } from '../Services/authRefresh';
import authStorage from '../Services/authStorage';

// Components Loading
import { Button } from 'primereact/button'; 
import { ScrollTop } from 'primereact/scrolltop';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';

import GlobalLoading from '../Components/GlobalLoading';

import jwtDecode from 'jwt-decode';

// External Libs loading
import routes from "../routes.js";
// TD-031: autorizacao ao lado da rota, nao so no menu.
import RouteGuard from "../Components/RouteGuard";
import ScrollToTop from "../Components/ScrollToTop";
import ChunkErrorBoundary from '../Components/ChunkErrorBoundary';
import * as config from '../Config/api.js';

// Import template images
import logo from '../Assets/Images/logoHeader.svg'; 
import iconProfile from '../Assets/Images/iconProfile.svg'; 
import formTopIcons from '../Assets/Images/formTopIcons.svg';  

// Load Actions
import * as AppActions from '../Store/Actions/App'

import AuthLogin from '../Components/Auth/AuthLogin';

// Load Components
import RegisterView from '../Screens/Home/RegisterModal';
import SelectAgencyView from '../Components/SelectAgencyModal';
import AlertView from '../Components/AlertModal';
import ValidateView from '../Components/ValidateModal';
import TopMenu from '../Components/TopMenu';

import TermsView from '../Components/TermsModal';
import PrivacyView from '../Components/PrivacyModal';
import DataView from '../Components/DataModal';
import CurrencyBox from '../Components/CurrencyBox';
import QuoteHeaderShortcut from '../Components/QuoteHeaderShortcut';

import logger from '../Services/logger';
import { clearUser as sentryClearUser } from '../Services/sentry';
import { phone } from '../Utils/phone';

import moment from 'moment';
import { Divider } from '@mui/material';

const Desktop = (props) => {

	// Set var from props
	const {
		setDialog,
		dialog,
		loginStatus,
		setLoginStatus,
		routePanel,
		setRoutePanel,
		currentAgency,
		setCurrentAgency,
		masterUser,
		agencyName,
		agencyUser,
		setMasterUser,
		setUserRights,
		setAgencyName,	
		setAgencyUser,
		setCurrentCompanyStatus,
		currentCompanyStatus,
		setActivationStatus,
		activationStatus,
		retrieveAndSetUserInfo,
		userRights
	} = props;
	
	// login status
	const [menuOpened,setMenuOpened] = React.useState(false);
	const [promptStatus,setPromptStatus] = React.useState(false);
	
// Alert control
const [validateRegistry, setValidateRegistry] = React.useState(false); 
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertAction, setAlertAction] = React.useState(""); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 	

// Global loading for User Data Loading If logged and not approved (only for under review or repproved status)
var logged = localStorage.getItem("@dream4/logged");
const [globalLoading, setGlobalLoading] = React.useState(logged == "1" ? true : false); 	

const [termsModal, setTermsModal] = React.useState(false); 
const [privacyModal, setPrivacyModal] = React.useState(false);
const [dataModal, setDataModal] = React.useState(false);

const [securedRoute, setSecuredRoute] = React.useState(true);

logger.debug('[securedRoute]--------->]'+JSON.stringify(securedRoute, null, 2));

// Set location
const location = useLocation();
const { hash, pathname, search } = location;
	
// set Use of history for PUSH 
var navigate = useNavigate();	
const op = React.useRef(null);

// Store socket first state
const socketRef = React.useRef(null);	

	const getRoutes = (routes) => {
	return routes.map((prop, key) => {
		return (
			<Route
			exact path={prop.path}
			element={<RouteGuard route={prop}><prop.component /></RouteGuard>}
			logOut={logOut}
			key={key}
			/>
		);
	});
	};  
  
	const onHide = () => {
	setMenuOpened(false);
	}  

	const onShow = () => {
	setMenuOpened(true);
	}    
		
	const handleClickScroll = (target) => {
		
	const element = document.getElementById(target);
	if (element) {
		// 👇 Will scroll smoothly to the top of the next section
		var elementPosition = element.offsetTop;
		element.scrollIntoView({ top: elementPosition - 70,behavior: 'smooth' });
	}
	};  
	
	 // Logoff method
	const logOut = () => {

		// Auth Fase 2: invalida sessão no servidor + limpa tokens novos (access em
		// memória/sessionStorage + refresh). Fire-and-forget; gated por refresh token.
		serverLogout();

		// Set logoff flag
		localStorage.setItem("@dream4/logged",0);

		// Remove userData
		localStorage.removeItem("@dream4/userData");
		localStorage.removeItem("@dream4/companyStatus");
		localStorage.removeItem("@dream4/activationStatus");

		// Limpa identificação no Sentry — issues posteriores ficam anônimas.
		sentryClearUser();

		if (socketRef.current) {
			socketRef.current.off('connect');
			socketRef.current.close();
		}

		// DESTROY ANY SELECTED AGENCY
		setCurrentAgency({});
		
		setLoginStatus(false);

		// Define a rota atual
		const currentRoute = routes.find(r => {
			// suporte a rotas dinâmicas tipo "/usuario/definir-senha/:token"
			const basePath = r.path.split('/:')[0];
			return location.pathname.startsWith(basePath);
		});

		// Verifica se é rota segura ou nao. Se for publica, nao redireciona.
		if (currentRoute && currentRoute.secured === false) {
		logger.debug('Rota pública detectada, não redirecionando para home após logout.');		
		return;
		}

		// Redirect to home on secured routes
		navigate("/home");
			
	}	

	// Actions to process accoring to websocket return
	const processWebsocketAction = (value) => {

		var action = value.action;

		switch (action) {

			case 'updateCompanyStatus':
					
				// Dont change master user activation status
				if (!masterUser) {
					setCurrentCompanyStatus(parseInt(value.newStatus));
					localStorage.setItem("@dream4/companyStatus",value.statusToken);	
				}
				
				break;
			case 'updateActivationStatus':
				
				// Dont change master user activation status
				if (!masterUser) {
					setActivationStatus(value.newStatus === "1" ? true : false);
				} // end if

			break;

			case 'forceLogoff':

				// only force logoff of non master user - to avoid drop main master logged user
				if (!masterUser) {
					setAlert(true);
					setAlertTitle("Você foi desconectado!"); 
					setAlertBody("Você foi desconectado pela administrador do sistema. Faça novamente o seu login."); 				
					logOut();
					navigate("/home");
				} // erd if

			break;

			case 'forceLogoffUserUpdated':

				// only force logoff of non master user - to avoid drop main master logged user
				if (!masterUser) {
					setAlert(true);
					setAlertTitle("Você foi desconectado!"); 
					setAlertBody(value?.message || "Você foi desconectado pela administrador do sistema pois seu usuário foi atualizado. Faça novamente o seu login."); 
					logOut();
					navigate("/home");
				} // erd if

			break;


			case 'rightsChanged':

				// Fase C: direitos do usuário mudaram. Renova o access (o backend
				// recomputa os direitos) e atualiza a UI SEM deslogar.
				refreshAccessToken()
					.then(() => {
						const info = authStorage.getDecodedAccessToken();
						if (info) {
							setMasterUser(info.Master === 0 ? false : true);
							setUserRights(info.Rights ? info.Rights : []);
						}
					})
					.catch(() => { /* se falhar, o próximo 401 dispara o fluxo padrão */ });

			break;

			case 'showMessage':

				// Dont show all message for master user
				if (!masterUser) {
					setAlert(true);
					setAlertTitle(value.title ? value.title : "Você recebeu uma mensagem");
					setAlertBody(value.message);
				} // end if

			break;

			default:
			  logger.debug("Nothing to do...");
		  }


	}

  // Execute when LocalStorage Changes TO AVOID HACKING ON BROWSER INSPECTOR
  const handleStorageChange = (event) => {


		logger.debug('Storage change detected! [2]');
		//logger.debug('event.key >>>> '+JSON.stringify(event.key,null,2));
		//logger.debug('event.oldValue >>>> '+JSON.stringify(event.oldValue,null,2));
		//logger.debug('event.newValue >>>> '+JSON.stringify(event.newValue,null,2));
//		logger.debug(event.key, event.oldValue, event.newValue, event.url, event.storageArea);

		if (event.key && loginStatus) {
			if (event.oldValue === null) {

			  logger.debug(`Item adicionado - chave: ${event.key}, valor: ${event.newValue}`);

			} else if (event.newValue === null) {

			  logger.debug(`Item removido - chave: ${event.key}, valor antigo: ${event.oldValue}`);
 
				// Check if userData Exist. If not, Logoff and redirect to Home
				var result = JSON.stringify(authStorage.getUserData() || {});
				var userData = JSON.parse(result); 
				var resultCompanyStatus = localStorage.getItem("@dream4/companyStatus");
				var resultActivationStatus = localStorage.getItem("@dream4/activationStatus");  
				var logged = localStorage.getItem("@dream4/logged");

				logger.debug('resultCompanyStatus >>>> '+JSON.stringify(resultCompanyStatus,null,2));
				logger.debug('resultActivationStatus >>>> '+JSON.stringify(resultActivationStatus,null,2));
				logger.debug('logged >>>> '+JSON.stringify(logged,null,2));

				// If there is no logged localStorage, logout
				if (!logged || logged == "0") {
					logOut();
					logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (1) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
					return;
				} // end if 

				// If any required localStorage Value is present, logout
				if (!authStorage.hasTabSession()) { setGlobalLoading(false); setLoginStatus(false); if (location.pathname !== "/" && location.pathname !== "/home") navigate("/"); return; }
		if (!userData || !resultCompanyStatus || !resultActivationStatus) {
					logOut();
					logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (2) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
					return;
				} // end if  

				try {
					var userDataTokenObjDecoded = jwtDecode(userData.userToken);
					if (!userDataTokenObjDecoded.CompanyPersonUserId) {
						logOut();
						logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (3) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
						return;
					} // end if 
				} catch(e) {
					logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (3.1) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
					logOut();
				} // end catch				

			} else {
			  logger.debug(`Item atualizado - chave: ${event.key}, valor antigo: ${event.oldValue}, valor novo: ${event.newValue}`);

				try {
					var userDataTokenObjDecoded = jwtDecode(userData.userToken);
					if (!userDataTokenObjDecoded.CompanyPersonUserId) {
						logOut();
						logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (3) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
						return;
					} // end if 
				} catch(e) {
					logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (6) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
					logOut();
				} // end catch

				// Set CurrentCompanyStatus
				let companyStatusFlag = false;
				if (resultCompanyStatus) { companyStatusFlag = true; }
				try {
					var companyStatusObjDecoded = jwtDecode(resultCompanyStatus); 
					var currentCompanyStatus = companyStatusObjDecoded.currentStatus;
					props.setCurrentCompanyStatus(currentCompanyStatus);
				} catch(e) {
					logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (7) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
					logOut();
				} // end catch
				
				// Set ActivationStatus
				let activationStatusFlag = false;
				if (resultActivationStatus) { activationStatusFlag = true; }	
				try {
					var activationStatusObjDecoded = jwtDecode(resultCompanyStatus);
					var activationStatus = activationStatusObjDecoded.currentStatus;
					props.setActivationStatus(activationStatus);
				} catch(e) {
					logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (8) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
					logOut();
				} // end catch		

			}
		  } else {
			logger.debug('Todo o storage pode ter sido limpo, ou uma chave nula foi manipulada');
		  }		

  };	
	
// Execute when route changes
React.useEffect(() => {

    // Função que você deseja executar a cada mudança de rota
   // logger.debug('A rota mudou!', location.pathname);
    
	// Retrieve User Data Obj. 
	var result = JSON.stringify(authStorage.getUserData() || {});
	var userData = JSON.parse(result);   

	  // If token dont exist, redirect to onboarding or register
	  if (authStorage.hasTabSession()) {
			  setLoginStatus(true);
			  return;
		  } // end if
		  else {
			  setLoginStatus(false);
		  }
    
  }, [location]); // Dependência do useEffect é a localização atual

// Run after mount component and Navigate changes
React.useEffect(() => {

	// Check if userData Exist. If not, Logoff and redirect to Home
	var result = JSON.stringify(authStorage.getUserData() || {});
	var userData = JSON.parse(result); 
	var resultCompanyStatus = localStorage.getItem("@dream4/companyStatus");
	var resultActivationStatus = localStorage.getItem("@dream4/activationStatus");  

	// If any required localStorage Value is present, logout
	if (!authStorage.hasTabSession()) { setGlobalLoading(false); setLoginStatus(false); if (location.pathname !== "/" && location.pathname !== "/home") navigate("/"); return; }
		if (!userData || !resultCompanyStatus || !resultActivationStatus) {
		logOut();
		return;
	} // end if  

	try {
		var userDataTokenObjDecoded = jwtDecode(userData.userToken);
		if (!userDataTokenObjDecoded.CompanyPersonUserId) {
			logOut();
			logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (11) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
			return;
		} // end if 
	} catch(e) {
		logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (11.1) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
		logOut();
	} // end catch	


	// redirect according to status
	if (loginStatus && currentCompanyStatus === 1 && activationStatus === true) {

		// Redirect to order if logged in and at home (lgin screen)
		if (location.pathname === "/" || location.pathname === "/home") {
			navigate("/order");
		}
		return;

	} // end if
	if (loginStatus && currentCompanyStatus === 1 && activationStatus === false) {
		navigate("/home");
		return;
	} // end if		
	else if (loginStatus && (currentCompanyStatus === 0 || currentCompanyStatus === 2 || currentCompanyStatus === 3)) {
		navigate("/home");

		// if review and activation is false, open activation modal. [CHECK IF KEEP]
		if(currentCompanyStatus === 0 && !activationStatus) {
			// setDialog('validateEmail',true);
		}

		return;
	} // end if	

  // Runs when UNMOUNT component
  return () => {
    
	// unmount...	
	
  };
  
}, [navigate]); // end useEffect 


React.useEffect(() => {

  // Verifica também se está na rota /home ou / (pública)
  const currentRoute = routes.find(r => {
    const basePath = r.path.split('/:')[0];
	const baseHomePath = r.path.split('/home')[0];
    return location.pathname.startsWith(basePath) || location.pathname.startsWith(baseHomePath);
  });

  // Define se a rota é segura ou não que impacta nos botoes do header
  let isSecured;
  if (currentRoute?.path == "/home"){
	isSecured = true;
  } else {
	isSecured = currentRoute ? currentRoute.secured : true;
  }

  // Só atualiza se mudar (evita loop infinito)
  if (isSecured !== securedRoute) {
    setSecuredRoute(isSecured);
  }

  logger.debug("[securedRoute atualizado] ->", isSecured);
}, [location.pathname]); // roda sempre que a rota muda


// Run one time after mount component
React.useEffect(() => {
  
   setRoutePanel(false);

    // Adiciona o listener do STORAGE ao montar o componente
    window.addEventListener('storage', handleStorageChange);   

   // Check if userData Exist. If not, Logoff and redirect to Home
	var result = JSON.stringify(authStorage.getUserData() || {});
	var userData = JSON.parse(result); 
	var resultCompanyStatus = localStorage.getItem("@dream4/companyStatus");
	var resultActivationStatus = localStorage.getItem("@dream4/activationStatus");  

	// If any required localStorage Value is present, logout
	if (!authStorage.hasTabSession()) { setGlobalLoading(false); setLoginStatus(false); if (location.pathname !== "/" && location.pathname !== "/home") navigate("/"); return; }
		if (!userData || !resultCompanyStatus || !resultActivationStatus) {
		setGlobalLoading(false);
		logOut();
		return;
	} // end if  
	 
	// check userToken
	try {
		var userDataTokenObjDecoded = jwtDecode(userData.userToken);
		if (!userDataTokenObjDecoded.CompanyPersonUserId) {
			setGlobalLoading(false);
			logOut();
			return;
		} // end if 
	} catch(e) {
		logOut();
		return;
	} // end catch	

	// Set Global loading on since its logged
	setGlobalLoading(true);
		
	// Set logged 
	localStorage.setItem("@dream4/logged", "1");
	setLoginStatus(true);

	var props = {
		setGlobalLoading:setGlobalLoading,
		logOut:logOut,
		setLoginStatus:setLoginStatus,
		setMasterUser:setMasterUser,
		setUserRights:setUserRights,
		setAgencyName:setAgencyName,
		setAgencyUser:setAgencyUser,
		setCurrentCompanyStatus:setCurrentCompanyStatus,
		setActivationStatus:setActivationStatus,
		setAlert:setAlert,
		setAlertTitle:setAlertTitle,
		setAlertBody:setAlertBody
	}
	var data = {
	  loginStatus: loginStatus
	}
	retrieveAndSetUserInfo(data,props);	

	// Runs when UNMOUNT component
	return () => {
		
		setRoutePanel(false);
		
		// Remove listener
		window.removeEventListener('storage', handleStorageChange);

		// Disconnect WEBSOCKET
		if (socketRef.current) {
			socketRef.current.off('connect');
			socketRef.current.close();
		}	
		
	};

}, []); // end useEffect 


// Check currentCompanyStatus changes and redirect if needed
React.useEffect(() => {

	  // redirect according to status
	  if (loginStatus && currentCompanyStatus === 1 && activationStatus) {

		  // Redirecione apenas se stiver na home (tela de login) / ou /home
		  if (location.pathname === "/" || location.pathname === "/home") {
			  navigate("/order");
		  }
		  return;

	  } // end if	
	  // redirect according to status
	  else if (loginStatus && currentCompanyStatus === 1 && !activationStatus) {
		navigate("/home");
		return;
	  } // end if		  
	  else if (loginStatus && (currentCompanyStatus === 0 || currentCompanyStatus === 2 || currentCompanyStatus === 3)) {
		navigate("/home");

		// if review and activation is false, open activation modal. [CHECK IF KEEP]
		if(currentCompanyStatus === 0 && !activationStatus) {
			// setDialog('validateEmail',true);
		}

		return;
	} // end if		  
  
}, [currentCompanyStatus,activationStatus]); // end useEffect

// Execute when loginStatus changes
React.useEffect(() => {
	
	  // if logged connect web socket. 
	  if (loginStatus) {

			// Set WEBSOCKET connection
			var result = JSON.stringify(authStorage.getUserData() || {});
			var userData = JSON.parse(result);     	

			socketRef.current = io(config.WS_URL, {
				auth: {
				// Fase 2: access FRESCO do authStorage (não o capturado).
				token: authStorage.getAccessToken()
				},
				transports: ['websocket'],  // força o uso de WebSocket
			});
			

			socketRef.current.on('mensagemDoServidor', (data) => {

				// Process action according to received data
				processWebsocketAction(data);

			});	

			// Connect WEBSOCKET only when mount — sempre com o access FRESCO
			// (reconnect também passa por aqui).
			socketRef.current.on('connect', () => {
				logger.debug('Conectado ao servidor WebSocket');
				socketRef.current.emit('autenticar', { token: authStorage.getAccessToken() });
			});

			socketRef.current.on('connect_error', (error) => {
				logger.debug('Erro de conexão:', error);
			  });

			  socketRef.current.on('connect_timeout', (timeout) => {
				logger.debug('Timeout de conexão:', timeout);
			  });

			  socketRef.current.on('error', (error) => {
				logger.debug('Erro geral:', error);
			  });

			// Fase C: após cada silent-refresh, reautentica o socket com o access novo.
			setOnRefreshed((newAccess) => {
				try {
					if (socketRef.current && socketRef.current.connected) {
						socketRef.current.emit('autenticar', { token: newAccess || authStorage.getAccessToken() });
					}
				} catch (e) { /* noop */ }
			});

			// Fase C: refresh proativo (~5min antes do exp) enquanto logado.
			startProactiveRefresh();

	  } // end if
	  else  {
		// Disconnect WEBSOCKET
		setOnRefreshed(null);
		stopProactiveRefresh();
		if (socketRef.current) {
			socketRef.current.off('connect');
			socketRef.current.close();
		}
	} // end if
  
}, [loginStatus]); // end useEffect 

	/* Logout prompt START  */
    const accept = (e) => {
	   logOut();
	  // op.current.toggle(e);
    };

    const reject = (e) => {
      // op.current.toggle(e);
    };
	
    const confirm = (event) => {
        confirmPopup({
            target: event.currentTarget,
            message: <div>Tem certeza que deseja <br /> fazer o logoff e sair?</div>,
            icon: 'pi pi-exclamation-triangle',
			accept,
            reject,
			rejectLabel:"Não",
			acceptLabel:"Sim"
        });
    };
	/* Logout prompt END  */	
	

/* Set current agency method */	
const setCurrentAgencyAction = () => {
	
	setDialog('selectAgencyModal',true);
	
} // end method

/* Set current agency method */	
const resetCurrentAgencyAction = () => {
	
	setCurrentAgency({});
	
	// Redirect to Order Start
	navigate("/order");
	
} // end method

// If globalLoading True, show loading screen
if (globalLoading) {
	return <GlobalLoading width="30vw" />;
}

// If globalLoading False, keep going
  return (
  <>
    <div className="wrapper">
      <div className="wrapper__header">
		
		{loginStatus && (
		<div className={masterUser ? "header__topbar header__topbar--master" : "header__topbar"}>
			<div className="header__topbar_phones">
				<a href={`https://api.whatsapp.com/send?phone=${phone.digits}`} target="_blank" rel="noopener noreferrer" className="header__phone">
					<i className="pi pi-whatsapp" style={{ color: "#25D366" }} /> {phone.displayBR}
				</a>
				<span className="header__phone_sep">|</span>
				<a href={`tel:${phone.telLocal}`} className="header__phone">
					<i className="pi pi-phone" style={{ color: "#814DE5" }} /> {phone.localOnly}
				</a>
			</div>
			<div className="header__topbar_left">{loginStatus && <QuoteHeaderShortcut variant="label" />}</div>
			<div className="header__topbar_right">
			<div className={!loginStatus ? "flex-1 dFlex align-items-center justify-center" : "flex-1-5 dFlex align-items-center justify-center"}>
			
			{!loginStatus &&
			<>
				<Button label="Login" rounded className="pT10 mR10 headerButton tColorWhite" style={{width:"130px"}} onClick={securedRoute ? ()=>handleClickScroll('loginSection') : () => navigate('/home')} />
				<Button label="Cadastre-se" text className="pT10 headerButton tColorPink" style={{width:"147px"}} onClick={securedRoute  ? () => setDialog('registerModal',true) : () => navigate('/home')} />
			</>
			}

			{loginStatus &&
			<>	

				
				
				{/*masterUser &&
				<>
				
						{!currentAgency.agencyCode &&
						<>
						<Button icon="pi pi-plus" size="large" rounded text aria-label="Menu" onClick={()=>setCurrentAgencyAction()} label="Selecionar agência" style={{fontSize:"1rem",color:"#222"}} />
						</>
						}
						
						{currentAgency.agencyCode &&
						<>
						<div className="loggedInWrapper"><span> Reservando como <strong>{currentAgency.agencyName}</strong> <br /> Funcionário: <strong>{currentAgency.employeeName}</strong> </span><Button icon="pi pi-times" size="small" rounded text aria-label="Menu" onClick={()=>resetCurrentAgencyAction()} label="Deslogar" style={{fontSize:"1rem",color:"#222"}} />
						</div>
						</>
						}

				</>
				*/}
			
				
				{/* IF inside admin module */}
				{pathname.includes("admin") &&
				<>
				<Button icon="pi pi-search" text aria-label="Buscar hotéis" onClick={(e) => {navigate("/order")}} label="Buscar hotéis" className="headerButton buscarHoteisBtn" style={{fontSize:"0.95rem"}} />
				</>
				 }				
			
			    {true &&
				<>
				<AuthLogin agencyUser={agencyUser} agencyName={agencyName} menuOpened={menuOpened} op={op} currentAgency={currentAgency} setCurrentAgencyAction={setCurrentAgencyAction}  />
				<OverlayPanel className="overlayPanel" onHide={onHide} onShow={onShow}  ref={op} style={{padding:"0 !important",backgroundColor:"#FFFFFF",width:"185px"}}>
									
					{/* Admin Top Menu */}
					<TopMenu op={op} confirm={confirm} />

					{/*{masterUser &&				
					<>
						<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Painel" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/dashboard");op.current.toggle(e);e.currentTarget.blur()}}  /></div>		
						
						<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Agências" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/agencies");op.current.toggle(e);e.currentTarget.blur()}} /></div>	

						<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Fila de aprovação" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/agenciesApproval");op.current.toggle(e);e.currentTarget.blur()}} /></div>	
					</>
					}				

					{(currentCompanyStatus === 1 || masterUser) &&
					<>
						<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Perfil da agência" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/agencyProfile");op.current.toggle(e);e.currentTarget.blur()}} /></div>		
						

						<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Perfil do usuário" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/userProfile");op.current.toggle(e);e.currentTarget.blur()}} /></div>							

						{(masterUser && userRights.includes('manageUsers')) && (
						<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Usuários Master" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/masterUsers");op.current.toggle(e);e.currentTarget.blur()}}  /></div>
						)}

						<Divider />

						{userRights.includes('manageUsers') && (		
						<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Usuários" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/users");op.current.toggle(e);e.currentTarget.blur()}}  /></div>)}


						<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Clientes" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/customers");op.current.toggle(e);e.currentTarget.blur()}}  /></div>

						{(userRights.includes('listBookings') || userRights.includes('all')) && (
						<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Reservas" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/reservations");op.current.toggle(e);e.currentTarget.blur()}}  /></div>)}
						
						<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",display:"flex",alignItems:"center"}} > <Button severity="secondary"  text label="Relatórios" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/reports");op.current.toggle(e);e.currentTarget.blur()}}  /> </div>
					</>
					}
					
					{masterUser &&
					<>
					{(userRights.includes('manageStock') || userRights.includes('all')) && <>
					<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Estoque — Propriedades" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/estoque/propriedades");op.current.toggle(e);e.currentTarget.blur()}} /></div>
					<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Estoque — Países" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/estoque/paises");op.current.toggle(e);e.currentTarget.blur()}} /></div>
					<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Estoque — Gerenciar" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/estoque/gerar");op.current.toggle(e);e.currentTarget.blur()}} /></div>
					<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Estoque — Regras de exceção" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/estoque/regras");op.current.toggle(e);e.currentTarget.blur()}} /></div>
					</>}
					{(userRights.includes('manageSettings') || userRights.includes('all')) &&
					<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}} ><Button severity="secondary"  text label="Configurações" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e)=>{navigate("/admin/configuracoes");op.current.toggle(e);e.currentTarget.blur()}} /></div>}
					</>
					}
					
					<ConfirmPopup />
					<Button label="Fazer logoff" className="mR10" style={{height:"42px",width:"100%",borderRadius:"0"}} onClick={(e) => {confirm(e)}} />*/}
					
				</OverlayPanel>				
				</>				
				}				
				
				
			</>				
			}
			
			</div>
			</div>
		</div>
		)}
		
		<div className="wrapper__header_container">
			<div className="flex-1" onClick={() => { if (loginStatus && currentCompanyStatus === 1 && activationStatus) {navigate("/order");}}} style={{cursor:"pointer"}}>
				<img src={logo} style={{width:"auto"}} className="noSelect" />
			</div>	
			<div className="flex-5 tAlignL pL40">
				<Button label="Quem somos" text className="pT10 headerButton" onClick={()=>handleClickScroll('memovoSection')} />
				<Button label="Dúvidas frequentes" text className="pT10 headerButton" onClick={()=>handleClickScroll('contatoSection')}  />
			</div>
			<div className="header__cambio">
				{loginStatus ? <CurrencyBox /> : (
					<>
						<Button label="Login" rounded className="pT10 mR10 headerButton tColorWhite" style={{width:"130px"}} onClick={securedRoute ? ()=>handleClickScroll('loginSection') : () => navigate('/home')} />
						<Button label="Cadastre-se" text className="pT10 headerButton tColorPink" style={{width:"147px"}} onClick={securedRoute ? () => setDialog('registerModal',true) : () => navigate('/home')} />
					</>
				)}
			</div>
							
		</div>
	  </div>
      <div className="wrapper__content">        
          <div className="wrapper__content_container home bgPurple">
		     <ScrollToTop />
		     <ChunkErrorBoundary>
		     <React.Suspense fallback={<GlobalLoading width="30vw" minHeight="70vh" />}>
		     <Routes>
				{getRoutes(routes)}
				<Route
					path="*"
					element={<Navigate to="/home" replace />}
				/>
			  </Routes>
			  </React.Suspense>
			  </ChunkErrorBoundary>
          </div>  
      </div>  
	  <div className="wrapper__footer" style={{height:"unset",background:"#00A3FF",backgroundColor:"#00A3FF"}}>
		<div className="wrapper__footer_container flex-column align-items-center justify-content-center" style={{padding:"20px 0",color:"#FFFFFF",gap:"1rem",paddingBottom:"3rem"}}>

			<div className="flex-row align-items-start justify-content-center" style={{gap:"3rem",fontSize:"0.9rem",maxWidth:"80%"}}>

				<div className="flex-column align-items-start justify-content-center flex-1" style={{gap:"0.5rem",textAlign:"left"}}>
						<div><h3>Quem é a SMI</h3></div>
						<div>A SMI é o nome comercial da SM Travel LTDA, agência de desenvolvimento de vendas e marketing dedicada ao mercado do turismo. Estando há mais de quatro décadas no mercado e dotada de impecável situação financeira a SMI atende marcas globais tais como a Enterprise Mobility, proprietária da Alamo, Enteprise e National, Design Hotels, San Francisco Travel e The Costa Rica Collection. A SMI também possui marcas próprias tais como a OTC - Online Travel Concierge, plataforma exclusiva de vendas de passeios, atrações e traslados.</div>
				</div>
				
				<div className="flex-column align-items-start justify-content-center" style={{gap:"0.5rem"}}>

					<div><h3>Informações Legais</h3></div>
					<Button label="Termos e condições de uso" link style={{padding:"unset",color:"#573497",fontWeight:"300",fontSize:"0.9rem"}} onClick={() => setTermsModal(true)} />
					<Button label="Política de privacidade" link style={{padding:"unset",color:"#573497",fontWeight:"300",fontSize:"0.9rem"}} onClick={() => setPrivacyModal(true)} />
					<Button label="Uso de dados" link style={{padding:"unset",color:"#573497",fontWeight:"300",fontSize:"0.9rem"}} onClick={() => setDataModal(true)} />

				</div>
				
				<div className="flex-column align-items-start justify-content-center flex-1" style={{gap:"0.5rem",textAlign:"left"}}>

					<div><h3>Contatos</h3></div>
					<div>Endereço: R. Praia de botafogo 440, Sala 702 <br /> Rio de Janeiro, RJ, CEP 22250-908</div>
					<div>Whatsapp: <a href={`tel:${phone.withDDI}`} style={{padding:"unset",textDecoration:"none",color:"#573497"}}>{phone.displayBR}</a></div>
					<div>Telefone: <a href={`tel:${phone.telLocal}`} style={{padding:"unset",textDecoration:"none",color:"#573497"}}>{phone.localOnly}</a></div>

				</div>
					
			</div>		

			<div className="flex-row align-items-end justify-content-center" style={{marginTop:"2rem",gap:"10rem",fontSize:"0.9rem"}}>
				<div className=" flex-1" style={{flexWrap:"nowrap"}}>&copy;2025 Todos os direitos reservados a SMTRAVEL LTDA</div>	
				<div>Made by <a href="http://smi.net.br/" target="_blank" style={{color:"#573497",textDecoration:"none",fontWeight:"bold"}}>SMI</a></div>	
			</div>	
			
		</div>

		
	  </div>
	  <ScrollTop threshold={100} />
    </div>
	
	<RegisterView
		setDialog={setDialog}
		dialog={dialog}
		alert={alert}
		setAlert={setAlert}
		setAlertTitle={setAlertTitle}
		setAlertBody={setAlertBody}	
		setAlertAction={setAlertAction}	
		setValidateRegistry={setValidateRegistry}		
	/>	

	<ValidateView
		alert={alert}
		setAlert={setAlert}
		setAlertTitle={setAlertTitle}
		setAlertBody={setAlertBody}	
		setAlertAction={setAlertAction}	
		validateRegistry={validateRegistry}
		setValidateRegistry={setValidateRegistry}
		scrollBlock={false}				
	/>	
	
	<SelectAgencyView
		setDialog={setDialog}
		dialog={dialog}
		setAlert={setAlert}
		setAlertTitle={setAlertTitle}
		setAlertBody={setAlertBody}
		scrollBlock={false}			
	/>		

	<AlertView
		alert={alert}
		setAlert={setAlert}
		alertTitle={alertTitle}
		alertBody={alertBody}
		alertAction={alertAction}
		scrollBlock={false}				
	/>

	<TermsView
		setTermsModal={setTermsModal}
		termsModal={termsModal}
		scrollBlock={true}
	/>	

	<PrivacyView
		setPrivacyModal={setPrivacyModal}
		privacyModal={privacyModal}
		scrollBlock={true}
	/>

	<DataView
		setDataModal={setDataModal}
		dataModal={dataModal}
		scrollBlock={true}
	/>	

	</>	
  );
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser,
  routePanel:store.appReducer.routePanel,
  loginStatus:store.appReducer.loginStatus,
  currentAgency:store.appReducer.currentAgency,
  agencyName:store.appReducer.agencyName,
  agencyUser:store.appReducer.agencyUser,
  currentCompanyStatus:store.appReducer.currentCompanyStatus,
  activationStatus:store.appReducer.activationStatus,
  userRights:store.appReducer.userRights,
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);


export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(Desktop);	
